import { z } from 'zod';

export const BuildSettingsSchema = z.object({
  disableNotifications: z.boolean().default(false).nullable().optional(),
  convertEmailBodyToPdf: z.boolean().optional().nullable(),
});

export type BuildSettings = z.infer<typeof BuildSettingsSchema>;
